"use client";

import type { ReactElement } from "react";
import { cloneElement, useRef } from "react";
import { useDisclosure } from "@ecco/ui/use-disclosure";
import type { BoxProps } from "@ecco/ui/box";
import { Box } from "@ecco/ui/box";
import ProfileHeader from "./profile-header";

interface ProfileHeaders {
    editButton?: string;
    editButtonAria?: string;
    hideEditing?: boolean;
    addAddress?: string;
    subHeading?: string;
    newButton?: string;
    newTitle?: string;
}

interface EditableProfileWrapperProps extends Omit<BoxProps, "children"> {
    data?: (string | null)[];
    title: string;
    headers: ProfileHeaders;
    children?: ReactElement<{ handleClose?: () => void }>;
    globalErrorHandler?: (error: unknown) => void;
}

export const EditableProfileWrapper = ({
    data,
    title,
    headers,
    children,
    globalErrorHandler,
    ...props
}: EditableProfileWrapperProps) => {
    const itemRef = useRef<HTMLDivElement>(null);
    const { isOpen, onClose, onOpen } = useDisclosure();
    const handleClose = () => {
        onClose();
        itemRef.current?.scrollIntoView({ block: "center", behavior: "smooth" });
    };
    const child = children ? cloneElement(children, { handleClose }) : null;
    return (
        <Box ref={itemRef} px={[3, 4, 6]} pt={6} pb={12} bg={"white"} {...props}>
            <ProfileHeader
                isExpanded={isOpen}
                data={data}
                remove={null}
                title={title}
                headers={headers}
                open={onOpen}
                onClose={handleClose}
            />
            {isOpen && <>{child}</>}
        </Box>
    );
};

export default EditableProfileWrapper;
